import React, { useState } from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';
import Tabs from 'ui/Tabs/Tabs';
import MobileSubtitle from 'ui/MobileSubtitle/MobileSubtitle';
import { INetwork } from '../../Beneficiaries.model';
import SingleMobileBen from './subtabs/SingleMobileBen/SingleMobileBen';
import BulkMobileBen from './subtabs/BulkMobileBen/BulkMobileBen';

const tabsOptions = [{ label: 'Single Beneficiaries' }, { label: 'Bulk Beneficiaries' }];

interface IMobileMoneyBen {
  networks: INetwork[];
}

const MobileMoneyBen = ({ networks }: IMobileMoneyBen) => {
  const [activeSubTab, setActiveSubTab] = useState<false | number>(0);

  const downMdScreen = useMediaQuery(useTheme().breakpoints.down('sm'));

  const handleOnChangeTab = (_event: React.ChangeEvent<unknown>, tabIndex: number) => {
    setActiveSubTab(tabIndex);
  };

  return (
    <>
      {downMdScreen && <MobileSubtitle>Select category</MobileSubtitle>}
      <Tabs
        value={activeSubTab}
        options={tabsOptions}
        onChange={handleOnChangeTab}
        theme={downMdScreen ? 'primary' : 'secondary'}
        disableVertical
        scrollButtons="auto"
      />
      {activeSubTab === 0 && <SingleMobileBen networks={networks} />}
      {activeSubTab === 1 && <BulkMobileBen networks={networks} />}
    </>
  );
};

export default MobileMoneyBen;
